import React from 'react';
import Middle from '../../../Middle/Middle';
import {MessageNode} from "../../../../Utils/messageObject/MessageNode.ts";

interface ChatPreviewProps {
    rootNode: MessageNode,
    messagesSequence: number[];
}

const ChatPreview: React.FC<ChatPreviewProps> = ({ rootNode, messagesSequence }) => {
    return (
        <div className="flex flex-col h-full w-full border border-neutral-900 dark:border-neutral-300 border-opacity-15 dark:border-opacity-15 rounded-xl">
            <Middle rootNode={rootNode} messagesSequence={messagesSequence} isPreview={true}/>
        </div>
    );
};

export default ChatPreview;